var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: _vm.formName,
      attrs: {
        model: _vm.form,
        rules: _vm.rules,
        "element-loading-text": "Logging you in...",
      },
    },
    [
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: "Authentication failed",
              type: "error",
              description: _vm.error,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: "Member Number",
            "inline-message": true,
            prop: "username",
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "Member number", size: "medium" },
            model: {
              value: _vm.form.username,
              callback: function ($$v) {
                _vm.$set(_vm.form, "username", $$v)
              },
              expression: "form.username",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: "Password",
            "inline-message": true,
            prop: "password",
          },
        },
        [
          _c("el-input", {
            attrs: {
              placeholder: "Please input password",
              size: "medium",
              "show-password": "",
            },
            model: {
              value: _vm.form.password,
              callback: function ($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-action" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-submit",
              attrs: { type: "primary", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [_vm._v("Login\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "inline-link",
              attrs: { type: "text" },
              on: { click: _vm.forgotPassword },
            },
            [_vm._v("Forgot my details")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }